import { Snackbar } from "@material-ui/core";
import React, { useState } from "react";
import MuiAlert from "@material-ui/lab/Alert";
import $ from "jquery";
import ProductService from "../../../services/ProductService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";

$(".custom-file-input").on("change", function () {
  var fileName = $(this).val().split("\\").pop();
  $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
});
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const PopupChangePriceDocument = ({ setOnUpdatePrice, updateDate }) => {
  const [open, setOpen] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [priceHTC, setPriceHTC] = useState();
  const [priceTTC, setPriceTTC] = useState();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onChangePriceHTC = (event) => {
    setPriceHTC(event.target.value);
  };

  const onChangePriceTTC = (event) => {
    setPriceTTC(event.target.value);
  };

  const onCancelButtonHandler = () => {
    setOpen(false);
    setOnUpdatePrice(false);
  };

  const onSetNewPrice = () => {
    ProductService.updatePriceDocument(
      getCurrentUserId(),
      updateDate.reference,
      updateDate.typeDocument,
      priceHTC,
      priceTTC
    )
      .then((response) => {
        setOpenAlert(true);

        setOnUpdatePrice(false);
        setOpen(false);
        window.location.reload(false);
      })
      .catch((e) => {
        console.log("error", e);
      });
  };

  return (
    <>
      <div class="modal fade" id="update-price">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-black">
              <h4 class="modal-title">Modifier le prix</h4>
            </div>
            <div class="modal-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="inputName">Nouveau Prix HTC</label>
                    <input
                      // defaultValue={oldBrandData.name}
                      onChange={onChangePriceHTC}
                      type="text"
                      id="inputName"
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="inputName">Nouveau Prix TTC</label>
                    <input
                      // defaultValue={oldBrandData.name}
                      onChange={onChangePriceTTC}
                      type="text"
                      id="inputName"
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button
                type="button"
                onClick={onCancelButtonHandler}
                class="btn btn-light"
                data-dismiss="modal"
              >
                Close
              </button>

              <button
                type="button"
                onClick={onSetNewPrice}
                class="btn btn-light"
              >
                Confirmer
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* <Modal open={open}>
        <Container className={classes.container}>
          <form className={classes.form} autoComplete="off">
            <div className={classes.item}>
              <TextField
                required
                id="standard-basic"
                label=" Taper le nouveau nom "
                defaultValue={oldBrandData.name}
                variant="outlined"
                size="small"
                style={{ width: "100%" }}
                onChange={onChangeName}
                InputProps={{
                  classes: { input: classes.input },
                }}
              />
            </div>
            <div className={classes.item}>
              <TextField
                id="outlined-multiline-static"
                multiline
                rows={4}
                InputProps={{
                  classes: { input: classes.input },
                }}
                defaultValue={oldBrandData.description}
                variant="outlined"
                label="Taper la nouvelle description"
                size="small"
                style={{ width: "100%" }}
                onChange={onChangeDesc}
              />
            </div>

            <div className={classes.cancelAndAddButtom}>
              <Button
                variant="outlined"
                color="primary"
                style={{ marginRight: 20 }}
                onClick={onAddBrand}
              >
                Valider
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={onCancelButtonHandler}
              >
                Cancel
              </Button>
            </div>
          </form>
        </Container>
      </Modal> */}
      <Snackbar
        open={openAlert}
        autoHideDuration={2000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleClose} severity="success">
          Ajout avec success !
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default PopupChangePriceDocument;
